import CryptoJS from 'crypto-js';
import JSEncrypt from 'jsencrypt';

const RSA_PUBLIC_KEY = 'MFwwDQYJKoZIhvcNAQEBBQADSwAwSAJBAKoR8mX0rGKLqzcWmOzbfj64K8ZIgOdHnzkXSOVOZbFu/TJhZ7rFAN+eaGkl3C4buccQd/EjEsj9ir7ijT7h96MCAwEAAQ==';

const randomString = () => {
    const chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
    let result = '';
    for (let i = 0; i < 32; i += 1) {
        result += chars.charAt(Math.floor(Math.random() * chars.length));
    }
    return result;
};

const encryptWithRsa = value => {
    const encryptor = new JSEncrypt();
    encryptor.setPublicKey(RSA_PUBLIC_KEY);
    return encryptor.encrypt(value);
};

export function encryptRequestBody(data) {
    const aesKey = CryptoJS.enc.Utf8.parse(randomString());
    const encryptKey = encryptWithRsa(CryptoJS.enc.Base64.stringify(aesKey));
    if (!encryptKey) {
        throw new Error('登录请求加密失败');
    }
    return {
        body: CryptoJS.AES.encrypt(JSON.stringify(data), aesKey, {
            mode: CryptoJS.mode.ECB,
            padding: CryptoJS.pad.Pkcs7
        }).toString(),
        encryptKey
    };
}
